var _clipPath;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEyeOpen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.41421
  },
  viewBox: "0 0 128 128"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M.151 0h128v128h-128z",
  style: {
    fill: "none"
  }
}), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "eye-open_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.151 0h128v128h-128z"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#eye-open_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#999",
  strokeWidth: 5,
  d: "M64.444 30.001c24.374.19 49.922 9.735 62.228 30.594.585.992 1.323 2.479 1.323 2.479.739 1.976-1.234 4.17-2.723 6.404C112.337 88.877 87.645 98 63.765 98c-24.269 0-50.062-9.445-62.05-30.589C1.1 66.326.336 64.69.336 64.69c-.52-1.494.721-3.14 1.684-4.753 11.808-19.784 36.516-29.743 61.276-29.936zm-1.127 4c-21.626.169-43.742 7.796-56.05 25.208-1.057 1.495-2.034 3.052-2.869 4.682 0 0 3.081 5.632 6.767 9.721 13.377 14.834 34.636 20.785 54.803 20.365 22.83-.475 46.856-9.45 57.836-29.797 0 0 .045-.454-.168-.839-10.846-19.342-35.36-29.154-59.213-29.34q-.553-.001-1.106 0Zm1.028 15c9.905.188 17.976 11.856 13.325 21.502-4.061 8.424-16.853 11.041-23.866 4.353-8.237-7.855-3.561-25.595 10.154-25.855zm-.336 4c-7.254.137-13.177 8.704-9.773 15.764 2.981 6.185 12.358 8.102 17.502 3.196 3.46-3.298 4.392-8.958 2.086-13.2-1.921-3.536-5.498-5.788-9.815-5.76Z",
  style: {
    fillRule: "nonzero"
  }
})));
export default SvgEyeOpen;